import { Button, Card, Grid, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, gridClasses, tableCellClasses, useMediaQuery } from '@mui/material'
import React, { useMemo, useState } from 'react'
import { makeStyles } from '@mui/styles';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDeleteOrderMutation, useGetUserOrdersQuery, useGetUserQuery, useUpdateOrderMutation } from '../../features/fullApi'
import ConfirmDialog from '../Modals/ConfirmDialog'
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Error403 from '../ErrorPages/Error403'
import ClipLoader from 'react-spinners/ClipLoader'
import Error500 from '../ErrorPages/Error500'
import { DataGrid } from '@mui/x-data-grid'
import OrderActions from './OrderActions'
import moment from 'moment'
import { grey } from '@mui/material/colors'
import { toast } from 'react-hot-toast'
import noOrder from '../Images/noorder.jpeg'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FCF6B1",
    color: "#000",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const UserOrders = () => {

  const user = JSON.parse(localStorage.getItem('user'))
  const params = useParams()

  const [pageSize, setPageSize] = useState(false)

    
  const [rowId, setRowId] = useState(null)

    const {data, error, isLoading} = useGetUserOrdersQuery(params.userId);
    const {data:dataUser, error:errorUser, isLoading:isLoadingUser} = useGetUserQuery({id: params.userId});
    const [open, setOpen] = useState(false)
    const [updateOrder] = useUpdateOrderMutation()
    const [deleteOrder] = useDeleteOrderMutation()

    const theme = useTheme()
 
    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));

    const columns = useMemo(() => [
      {field:'_id', headerName:'Order Id', width:100},
      {field:'status', headerName:'Status', width:100,  
      type: 'singleSelect',   
      valueOptions: ['pending', 'shipped', 'fullfilled', 'canceled'],
      editable: true},

      {field:'createdAt', 
      headerName:'createdAt', 
      width:300, 
      rederCell:params=>moment(params.row.createdAt).format('YYYY-MM-DD HH:MM:SS'),
      filterable:false
      },
      {
        field: 'Order Details',
        headerName: 'Order Details',
        width: 150,
        renderCell:params=> <Button variant="outlined" onClick={() => navigate(`/order/${params.row._id}`)}>View</Button>,
        sortable:false,
        filterable:false
      },
      {
        field: 'save',
        headerName: 'Save',
        type: 'save',
        sortable:false,
        filterable:false,
        renderCell: (params) => (
          <OrderActions {...{ params, rowId, setRowId }} />
        ),
      },
    ], [rowId])
  
    const useStyles = makeStyles({
      root: {
          "& .MuiTableCell-head": {
              color: "white",
              backgroundColor: "blue"
          },
      }
    });

    const Root = styled('div')(({ theme }) => ({
      [theme.breakpoints.down('md')]: {
        typography: {
          fontSize: 14,
        },
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up('md')]: {
        typography: {
          fontSize: 20,
        },
        padding: theme.spacing(5),
      },
      [theme.breakpoints.up('lg')]: {
        typography: {
          fontSize: 22,
        },
        padding: theme.spacing(7),
      },
    }));

    const updateOrderStatus = async (orderId, newStatus) => {
      updateOrder({_id: orderId, status: newStatus},{id: orderId})
      .then(res => console.log("Res", res))
      .catch(err => console.log("err", err))
    }

    const openDeleteModal = ((productId) => {
      setOpen(true)
    })

    const handleDeleteOrder = ((orderId) => {
      setOpen(false)
      deleteOrder({id: orderId.id}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
    })

    console.log("ERROR###", error)
    console.log("ERRORUSER###", errorUser)
    console.log("LOADING###", isLoading)
    console.log("LOADINGUSER###", isLoadingUser)
    console.log("RES###", data)
    console.log("RESUSER###", dataUser)

    
    const message = "Are you sure you want to delete this order?"
    const navigate = useNavigate()
    window.scrollTo(0, 0)

    const renderMobileOrders = () => (
      isLoading ? (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 130px)'}}>
      <ClipLoader
        color="#93032E"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>   ) 
      : error ? (<Error500></Error500>)
      :(
      <Root> 
      {user.isAdmin && 
        <div style={{textAlign: 'center'}}>
          <Button variant="contained" color="secondary" size="small" style={{width: "150px", textAlign: 'center'}} onClick={() => navigate(-1)}>Back</Button>
        </div>
      }
        <h2 style={{textAlign: 'center'}}>Orders</h2>
        {(!error && !errorUser && data && data.length > 0 && dataUser) ? 
        <Grid container spacing={3} style={{width: '100%', margin: '0'}}>
              {data ?
              <div>
              {data?.map((ord) => (
                <Grid item xs={12}>
                  <Card style={{padding: '20px', margin: '20px'}}>
                  <p>Order no: {ord._id}</p>
                    <p style={{marginLeft: '20px'}}>Total amount: {ord.amount}</p>
                    <Button style={{width: '150px', marginLeft: '20px'}} variant="contained" size="small" element={Link} onClick={() => navigate(`/order/${ord._id}`)}>See order details</Button>

                    <div>
                      <p className="orderStatus" style={{width: '100px', textAlign: 'center'}}><span className={`${ord.status}`}>{ord.status}</span></p>
                      {ord.status === "pending" && !user?.isAdmin ? 
                      <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "canceled")}>Cancel</Button>
                      : ""}
                      <>
                      </>
                      {user.isAdmin &&
                      <>
                        {ord.status === "pending" &&
                        <>
                          <Button style={{width: '100px', marginLeft: '20px'}}  size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "shipped")}>Ship</Button>
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "canceled")}>Cancel</Button>
                        </>
                        }
                        {ord.status === "shipped" &&
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "fulfilled")}>Fulfilled</Button>
                        }
                        {/* <>
                        {ord.status === "canceled" &&
                          <>
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="error" onClick={() => openDeleteModal()}>Delete</Button>
                          <ConfirmDialog open={open} handleDelete={handleDeleteOrder} setOpen={setOpen} item={ord} message={message}></ConfirmDialog>
                          </>
                        }               
                        </> */}
                      </>
                      }
                    </div> 
                  </Card>
                </Grid>
               ))}
              </div>
              :
              <div>
                {data?.map((ord) => (
                <Grid item xs={12}>
                    <p>Order no: {ord._id}</p>
                    <p>Total amount: {ord.amount} $</p>
                    <Button style={{width: '200px', marginLeft: '20px'}} variant="contained" size="small" element={Link} onClick={() => navigate(`/order/${ord._id}`)}>See order details</Button>
                </Grid>
               ))}
              </div>
          }
        </Grid> : 
        <>
        <div style={{display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center'}}>
        {user?.isAdmin && (<Typography variant="subtitle1" style={{marginBottom:'20px'}}>{dataUser?.username} hasn't placed any orders yet</Typography>)}
        <img src={noOrder} alt="no orders img" style={{width:'250px', height:'250px'}}/>
        </div>
        </>}
      </Root>
      )
    )

    const renderTabletOrders = () => (
      isLoading ? (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
      <ClipLoader
        color="#93032E"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>   ) 
      : error ? (<Error500></Error500>)
      :(
      <Root> 
        <h2 style={{textAlign: 'center'}}>Orders</h2>
        <Grid container spacing={4} style={{width: '100%', margin: '0'}}>
              {data ?
              <>
              {data?.map((ord) => (
                <Grid item xs={12} sm={6} md={3} style={{display: 'flex', justifyContent:'center', alignItems:'center', width: '100%'}}>
                  <Card style={{padding: '20px', margin: '20px'}}>
                  <p>Order no: {ord._id}</p>
                    <p style={{marginLeft: '20px'}}>Total amount: {ord.amount}</p>
                    <Button style={{width: '150px', marginLeft: '20px'}} variant="contained" size="small" element={Link} onClick={() => navigate(`/order/${ord._id}`)}>See order details</Button>

                    <div style={{display: 'flex', alignItems: 'center', width: '250px'}}>
                      <p className="orderStatus" style={{width: '100px', textAlign: 'center'}}><span className={`${ord.status}`}>{ord.status}</span></p>
                      {ord.status === "pending" && !user?.isAdmin ? 
                      <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "canceled")}>Cancel Order</Button>
                      : ""}
                      <>
                      </>
                      {user.isAdmin &&
                      <>
                        {ord.status === "pending" &&
                        <>
                          <Button style={{width: '100px', marginLeft: '20px'}}  size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "shipped")}>Ship</Button>
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "canceled")}>Cancel</Button>
                        </>
                        }
                        {ord.status === "shipped" &&
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="primary" onClick={() => updateOrderStatus(ord._id, "fulfilled")}>Fulfilled</Button>
                        }
                        <>
                        {ord.status === "canceled" &&
                          <>
                          <Button style={{width: '100px', marginLeft: '20px'}} size="small" variant="contained" color="error" onClick={() => openDeleteModal()}>Delete Order</Button>
                          <ConfirmDialog open={open} handleDelete={handleDeleteOrder} setOpen={setOpen} item={ord} message={message}></ConfirmDialog>
                          </>
                        }               
                        </>
                      </>
                      }
                    </div> 
                  </Card>
                
                </Grid>
               ))}
              </>
              :
              <>
                {data?.map((ord) => (
                <Grid item xs={12} style={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <p>Order no: {ord._id}</p>
                    <p style={{marginLeft: '20px'}}>Total amount: {ord.amount}</p>
                    <Button style={{width: '200px', marginLeft: '20px'}} variant="contained" size="small" element={Link} onClick={() => navigate(`/order/${ord._id}`)}>See order details</Button>
                </Grid>
               ))}
              </>
          }
        </Grid> 
      </Root>
      )
    )

    const renderDesktopOrders = () => (
    (isLoading && isLoadingUser) ? (
        <div 
        style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>) : 
      (!error && !errorUser && dataUser && data) && 
      (    
      (data.length > 0) ? (  
       <div style={{width: '1200px', margin:'122px  auto 0px', height:'100vh'}}>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'40px'}}>
          <Typography variant="h5" style={{marginRight:'10px'}}>Orders of </Typography>
          <Typography variant="h5" color="primary" sx={{fontWeight:'bold'}}>{dataUser?.username}</Typography>

        </div>
       <DataGrid 
        columns={columns}
        rows={data}
        getRowId={(row) => row._id}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        pagination
        getRowSpacing={params => ({
          top:params.isFirstVisible ? 0 : 5,
          bottom: params.isLastVisible ? 0 : 5,
        })}
        sx={{
          [`& .${gridClasses.row}`] : {
            bgcolor: theme=>theme.palette.mode === "light" ? grey[200] : grey[900]
          }
        }}
        onCellEditStop={(params) => 
          {
            if(params.row.isAdmin) {
              toast("User is already admin")
            } else {
            setRowId(params.id)
            }
          }
        }
      />
      </div>) : 
      (<div style={{height:'100vh', display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center'}}>
        {user?.isAdmin && (<Typography variant="h4" style={{marginBottom:'50px'}}>{dataUser.username} hasn't placed any orders yet</Typography>)}
        <img src={noOrder} alt="no orders img" style={{width:'500px', height:'500px'}}/>
      </div>))
    )

    return (
      <div>
        {!error ?
          (
          (isXs) ?  renderMobileOrders() : 
          (isSm) ? renderMobileOrders() :
          (isMd) ? renderTabletOrders() :
          renderDesktopOrders()
          ) : (
            <Error403></Error403>
          )
        }
      </div>
    );
}

export default UserOrders